import { Redirect, Route } from "react-router";
import React from "react";

function RedirectTo({
    to = "/",
    location: from,
}: {
    to: string;
    location: string;
}) {
    return <Redirect to={{ pathname: to, state: { from } }} />;
}

const AuthRoute = ({
    isAuth,
    component: C,
    ...rest
}: {
    isAuth: boolean;
    component: any;
}) => (
    <Route
        {...rest}
        render={(props: Record<any, any>) =>
            isAuth ? (
                <C {...props} />
            ) : (
                <RedirectTo
                    to="/app/login"
                    location={props.location}
                    {...props}
                />
            )
        }
    />
);

const AdminRoute = ({
    isAuth,
    isAdmin,
    component: C,
    ...rest
}: {
    isAuth: boolean;
    isAdmin: boolean;
    component: any;
}) => (
    <Route
        {...rest}
        render={(props: Record<string, any>) =>
            isAuth && isAdmin ? (
                <C {...props} />
            ) : (
                <RedirectTo
                    to={props.to}
                    location={props.location}
                    {...props}
                />
            )
        }
    />
);

function pathRoutes({
    paths,
    Page,
    Route,
    ...rest
}: {
    paths: string[];
    Page: React.Component;
    [x: string]: any;
}) {
    return paths.map((path) => (
        <Route {...rest} key={path} path={path} exact={true} component={Page} />
    ));
}

export function configureRoutes({
    list,
    isAuth = false,
    isAdmin = false,
    ...props
}: {
    list: Record<string, any>;
    isAuth: boolean;
    isAdmin: boolean;
    [x: string]: any;
}): any {
    return Object.keys(list).map((p) => {
        const { paths, requiresAuth, requiresAdmin } = list[p];
        const Page = list[p];

        if (!requiresAuth && !requiresAdmin) {
            return pathRoutes({ ...props, paths, Page, Route: Route });
        }

        if (requiresAdmin) {
            return pathRoutes({
                ...props,
                paths,
                Page,
                Route: AdminRoute,
                isAuth,
                isAdmin,
            });
        }

        if (requiresAuth) {
            return pathRoutes({ paths, Page, Route: AuthRoute, isAuth });
        }

        return null;
    });
}
